module.exports = __webpack_public_path__ + "static/media/mascara.3fd7227a.png";